import {request} from "./request";

export const getProject = queryParams => {
  return request.get({
    path: "/engine/project/info",
    queryParams,
  });
};

export const getProjectList = queryParams => {
  return request.get({
    path: "/engine/project/list",
    queryParams,
  });
};

export const createProject = params => {
  return request.post({
    path: "/engine/project/create",
    params,
  });
};

export const updateProject = (queryParams, params) => {
  return request.put({
    path: "/engine/project/update",
    queryParams,
    params,
  });
};

export const deleteProject = queryParams => {
  return request.delete({
    path: "/engine/project/delete",
    queryParams,
  });
};

export const uploadProjectThumbnail = params => {
  return request.post({
    path: "/engine/project/thumbnail/upload",
    params,
  });
};

export const uploadProjectScene = params => {
  return request.post({
    path: "/engine/project/scene/upload",
    params,
  });
};
